export const XERO_ACCOUNT_CODES = {
  WHOLE_CARCASE: '200',
  BROKEN_CARCASE: '201',
  CARTONS_BSP: '202',
  CARTONS_PURCHASED: '203'
}

const WHOLE_CARCASE_PRODUCT_CODES = ['10']

const BROKEN_CARCASE_PRODUCT_CODES = [
  '119', // Trunk
  '118', // Haunch
  '55', // Legs
  '98', // Saddle
  '45' // Forequarter
]

function normaliseProductCode(productCode) {
  return String(productCode || '').trim()
}

function isSixDigitCodeStartingWith4(code) {
  return /^4\d{5}$/.test(code)
}

function isSixDigitCodeStartingWith7(code) {
  return /^7\d{5}$/.test(code)
}

function isFourDigitCode(code) {
  return /^\d{4}$/.test(code)
}

export function getXeroAccountCodeByProductCode(productCode) {
  const code = normaliseProductCode(productCode)

  if (!code) {
    return ''
  }

  if (WHOLE_CARCASE_PRODUCT_CODES.includes(code)) {
    return XERO_ACCOUNT_CODES.WHOLE_CARCASE
  }

  if (BROKEN_CARCASE_PRODUCT_CODES.includes(code)) {
    return XERO_ACCOUNT_CODES.BROKEN_CARCASE
  }

  if (isSixDigitCodeStartingWith4(code)) {
    return XERO_ACCOUNT_CODES.CARTONS_BSP
  }

  if (isFourDigitCode(code) || isSixDigitCodeStartingWith7(code)) {
    return XERO_ACCOUNT_CODES.CARTONS_PURCHASED
  }

  return ''
}
